module.exports = __webpack_public_path__ + "img/3.e2ee4b56.jpg";